import { render, staticRenderFns } from "./Favoritescard.vue?vue&type=template&id=ee4f7648&scoped=true&"
import script from "./Favoritescard.vue?vue&type=script&lang=js&"
export * from "./Favoritescard.vue?vue&type=script&lang=js&"
import style0 from "./Favoritescard.vue?vue&type=style&index=0&id=ee4f7648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee4f7648",
  null
  
)

export default component.exports